export default "__VITE_ASSET__atlfhX4g__"